// components/ModalSlider.js
import React from "react";
import styled from "styled-components";

const ModalSlider = ({ images, currentIndex, setCurrentIndex }) => {
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <SliderWrapper>
      {images.length > 1 && (
        <ArrowButton onClick={handlePrev}>{"<"}</ArrowButton>
      )}
      <img src={images[currentIndex]} alt="Slider" />
      {images.length > 1 && (
        <ArrowButton onClick={handleNext}>{">"}</ArrowButton>
      )}
    </SliderWrapper>
  );
};

const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
  }
`;

const ArrowButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  color: white;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    left: 10px;
  }

  &:last-child {
    right: 10px;
  }
`;

export default ModalSlider;
